<template>
    <div class="container" :style="'max-width:'+width+'px'">
        <div class="row h-100 align-items-center">
            <div class="col">

                <brand class="mb-5 text-center" v-if="brand"></brand>

                <slot></slot>

            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            width: {
                type: Number,
                default: 400
            },
            brand: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
    .content {
        height: 100vh;
    }
    .container {
        height: 80vh;
    }
</style>
